import { BlockText, GridContainer, GridItem, ViewSection } from "@duosoftbg/nacid-components";

const MainDetailsDisplay = ({ record }) => {
  return (
    <ViewSection label={"t.main.details"}>
      <GridContainer spacing={3} mt={0}>
        <GridItem sm={12} md={12} lg={12}>
          <BlockText label={"l.name"} text={record.name} />
        </GridItem>
        {record.description ? (
          <GridItem sm={12} md={12} lg={12}>
            <BlockText label={"l.description"} text={record.description} />
          </GridItem>
        ) : null}
      </GridContainer>
    </ViewSection>
  );
};
export default MainDetailsDisplay;
